import { companyListViewTexts } from './company-list';
import { companyRootViewTexts } from './company-root';
import { dndAreaViewTexts } from './dnd-area';
import { koumutenListViewTexts } from './koumuten-list';
import { labelListViewTexts } from './label-list';
import { modelDetailViewTexts } from './model-detail';
import { modelImageListViewTexts } from './model-image-list';
import { modelListViewTexts } from './model-list';
import { modelRootViewTexts } from './model-root';
import { notFoundPageViewTexts } from './not-found';
import { projectDetailViewTexts } from './project-detail';
import { projectImageListViewTexts } from './project-image-list';
import { projectListViewTexts } from './project-list';
import { projectRootViewTexts } from './project-root';
import { userListViewTexts } from './user-list';
import { csvListViewTexts } from './csv-list';

export const pagesViewTexts = {
  koumutenList: koumutenListViewTexts,
  companyList: companyListViewTexts,
  companyRoot: companyRootViewTexts,
  dndArea: dndAreaViewTexts,
  projectImageList: projectImageListViewTexts,
  labelList: labelListViewTexts,
  modelDetail: modelDetailViewTexts,
  modelList: modelListViewTexts,
  modelRoot: modelRootViewTexts,
  notFound: notFoundPageViewTexts,
  projectDetail: projectDetailViewTexts,
  projectList: projectListViewTexts,
  projectRoot: projectRootViewTexts,
  modelImageList: modelImageListViewTexts,
  userList: userListViewTexts,
  csvList: csvListViewTexts
} as const;
